import { render, staticRenderFns } from "./DialogEditAvatar.vue?vue&type=template&id=5223b32e"
import script from "./DialogEditAvatar.vue?vue&type=script&lang=js"
export * from "./DialogEditAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports